if ( typeof ProductSlider !== "function" ) {

  class ProductSlider extends HTMLElement {

    constructor(){

      super();

      const ua = navigator.userAgent.toLowerCase();
      this._ios15 = ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) && ua.includes('applewebkit') && ( ua.includes('os 15_') || ua.includes('version/15') );

      this.classList.add('js-enabled');

      this.viewport = this.querySelector('.product-gallery__viewport');
      this.container = this.querySelector('.product-gallery__container');
      this.holder = this.querySelector('.product-gallery__items');
      this.items = this.querySelectorAll('.product-gallery__item');

      // ------------TD CHANGE-----------
      // Bundle gallery uses a "thumbnails below" layout. This flag gates
      // every change below, so non-bundle galleries keep the legacy path.
      this.thumbnailsBelow = this.closest('.product__gallery')?.dataset.thumbnailsPosition === 'below';
      // ----------END TD CHANGE---------

      this.index = this.dataset.initialIndex ? parseInt(this.dataset.initialIndex) : 0;
      this.length = this.items.length;

      this.timeout = null;
      this.animating = false;

      this._mobilePadding = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--grid-padding'));

      this.changeSlide = index => {

        if ( this.mobile ) {

          this._iOS15snapping();
          this.holder.scrollTo({
            left: this.items[index].offsetLeft - parseInt(getComputedStyle(this.items[index]).marginLeft),
            top: 0,
            behavior: 'smooth'
          });

          this._checkNav(index);
          this._checkIndex(true);
          this._setHeight();

        } else {

          this._blockAnimation(true);
          this._resetClasses();

          if ( index > this.index ) {

            let prevIndex = this.index;
            this.index = index-1;

            this.holder.classList.add('no-transitions');
            this._resetClasses();
            this._resetOrder([prevIndex, this.index]);
            this.holder.style.transform = `translateX(${( this.index * this.width * - 1 )}px`;
            this.items[prevIndex].classList.add('active');
            this.items[index].classList.add('after-active');
            this._checkNav(index);

            setTimeout(()=>{
              this.holder.classList.remove('no-transitions');
              this.items[prevIndex].classList.remove('active');
              this.items[prevIndex].classList.add('before-active');
              this.holder.style.transform = `translateX(${( index * this.width * - 1 )}px`;
              this.items[index].classList.remove('after-active');
              this.items[index].classList.add('active');
              this.index = index;
              this.dispatchEvent(this.EVENT_CHANGE);
            }, 10);

          } else if ( index < this.index ) {
              
            let prevIndex = this.index;
            this.index = index+1;

            this.holder.classList.add('no-transitions');
            this._resetClasses();
            this._resetOrder([prevIndex, this.index]);
            this.holder.style.transform = `translateX(${( this.index * this.width * - 1 )}px`;
            this.items[prevIndex].classList.add('active');
            this.items[index].classList.add('before-active');
            this._checkNav(index);

            setTimeout(()=>{
              this.holder.classList.remove('no-transitions');
              this.items[prevIndex].classList.remove('active');
              this.items[prevIndex].classList.add('after-active');
              this.holder.style.transform = `translateX(${( index * this.width * - 1 )}px`;
              this.items[index].classList.remove('before-active');
              this.items[index].classList.add('active');
              this.index = index;
              this.dispatchEvent(this.EVENT_CHANGE);
            }, 10);

          }

        }

        this._setHeight(index);
        
      }

      this.toggleDragging = toggle => {
        if ( ! toggle ) {
          this.container.classList.add('force-no-drag');
        } else {
          this.container.classList.remove('force-no-drag');
        }
      }

      this.EVENT_CHANGE = new Event('change');
      this.EVENT_SETTLE = new Event('settle');

      // Add navigation buttons

      const navEl = document.createElement('div');
      navEl.setAttribute('class', `product-gallery__navigation ${this.dataset.navClass ? this.dataset.navClass : 'five-tenths lap--six-tenths smaller-lap--eleven-tenths push-left-one-tenth lap--push-left-none smaller-lap--push-left-padding'}`); 
      navEl.innerHTML = `
        <div class="product-gallery__no">
          <span class="product-gallery__index">${(this.index+1)}</span> / ${this.length}
        </div>
        <button class="product-gallery__prev simple-arrow simple-arrow--left">
          <span class="visually-hidden">${KROWN.settings.locales.prev}</span>
          ${KROWN.settings.symbols.arrow}
        </button>
        <button class="product-gallery__next simple-arrow simple-arrow--right">
          <span class="visually-hidden">${KROWN.settings.locales.next}</span>
          ${KROWN.settings.symbols.arrow}
        </button>`;
      // ------------TD CHANGE-----------
      // Thumbnails-below mode mounts the nav inside the viewport so the
      // arrows track the image height. Legacy mode keeps the original mount.
      if (this.thumbnailsBelow && this.viewport) {
        this.viewport.appendChild(navEl);
      } else {
        this.appendChild(navEl);
      }
      // ----------END TD CHANGE---------

      this.indexEl = this.querySelector('.product-gallery__index');
      this.prevEl = this.querySelector('.product-gallery__prev');
      this.nextEl = this.querySelector('.product-gallery__next');

      this.prevEl.addEventListener('click', ()=>{
        this.prevSlide();
      });

      this.nextEl.addEventListener('click', ()=>{
        this.nextSlide();
      });

      this.querySelectorAll('.product-gallery__prev, .product-gallery__next').forEach(elm=>{
        elm.addEventListener('keydown', e=>{
          if ( e.keyCode == window.KEYCODES.RETURN ) {
            window.scrollY = this.container.offsetTop - 100;
            setTimeout(()=>{
              this.items[this.index].focus();
            }, 50);
          }
        });
      });

      // Set up mobile swipping

      this.container.addEventListener('touchstart', e=>{
        if ( ! this.mobile && ! this.container.classList.contains('force-no-drag') ) {
          this.touchX = e.touches[0].screenX;
          this.container.classList.add('dragging-enabled');
        }
      }, {passive:true});
      this.container.addEventListener('touchmove', e=>{
        if ( ! this.mobile && this.container.classList.contains('dragging-enabled') && ! this.container.classList.contains('force-no-drag') ) {
          let direction = this.touchX - e.touches[0].screenX;
          if ( direction > 0 ) {
            this.nextSlide();
            this.container.classList.remove('dragging-enabled');
          } else if ( direction < 0 ) {
            this.prevSlide();    			
            this.container.classList.remove('dragging-enabled');
          }
        }
      }, {passive:true});
      this.container.addEventListener('touchend', e=>{
        if ( ! this.mobile ) {
          this.container.classList.remove('dragging-enabled');
        }
      }, {passive:true});

      // Set up desktop grabbing

      this.container.addEventListener('mousedown', e=>{
        if ( ! this.mobile && ! this.container.classList.contains('force-no-drag') ) {
          this.mouseX = e.screenX;
          this.container.classList.add('dragging-enabled');
          this.container.classList.add('mouse-down');
        }
      });
      this.container.addEventListener('mouseup', e=>{
        if ( ! this.mobile ) {
          this.container.classList.remove('mouse-down');
          this.container.classList.remove('pointer-events-off');
          this.container.classList.remove('dragging-enabled');
        }
      });

      this.container.addEventListener('mousemove', e=>{
        if ( ! this.mobile && this.container.classList.contains('dragging-enabled') && ! this.container.classList.contains('force-no-drag') ) {
          let direction = this.mouseX - e.screenX;
          if ( Math.abs(direction) > 1 ) {
            this.container.classList.add('pointer-events-off');
            if ( direction > 0 ) {
              this.nextSlide();
              this.container.classList.remove('dragging-enabled');
            } else if ( direction < 0 ) {
              this.prevSlide();
              this.container.classList.remove('dragging-enabled');
            }
          }
        }
      });

      // mobile scroll event

      this.OBSERVER = new IntersectionObserver(entries=>{
        // ------------TD CHANGE-----------
        if ( this.mobile && !this._programmaticScroll ) {
        // ----------END TD CHANGE---------
          entries.forEach(entry=>{
            if ( entry.intersectionRatio >= .3 ) {
              this.index = parseInt(entry.target.getAttribute('data-index'));
              this._checkNav();
              this._checkIndex(true);
              this._setHeight();
              this.dispatchEvent(this.EVENT_CHANGE);
            }
          });
        }
      }, {
        threshold: [0, .3]
      });
      this.items.forEach(slide=>{
        this.OBSERVER.observe(slide);
      });

      // Initial reset

      this._checkMobile();
      this._resetOrder();
      this._checkIndex();
      this._checkNav();
      this._setHeight();
      this._getSliderWidth();
      setTimeout(()=>{
        this._getSliderWidth();
        this._repositionSlider();
      }, 100);
      this._repositionSlider();
      this.EVENT_RESIZE = ()=>{
        this._checkMobile();
        this._setHeight();
        this._getSliderWidth();
        this._repositionSlider();
        this._mobilePadding = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--grid-padding'));
      };
      // Store bound method reference for later removal
      this.boundResizeHandler = this.EVENT_RESIZE;
      window.addEventListener('resize', this.boundResizeHandler);
      window.addEventListener('td:section-switcher-changed', this.boundResizeHandler);
      this.items[this.index].classList.add('enable-tab');

      if ( this.mobile ) {
        this.holder.scrollLeft = this.items[this.index].offsetLeft;
      }
      // ------------TD CHANGE-----------

      this.enableThumbnails = this.dataset.enableThumbnails === 'true';
      this.thumbnailsContainer = this.querySelector('.product-gallery__thumbnails');
      this.thumbnails = this.thumbnailsContainer?.querySelectorAll('img');
      
      // Mobile thumbnails are outside the slider element, so we need to look in the parent
      this.mobileThumbnailsContainer = this.closest('.product__gallery')?.querySelector('.product-gallery__thumbnails--mobile');
      this.mobileThumbnails = this.mobileThumbnailsContainer?.querySelectorAll('img');
      if((this.thumbnailsContainer && this.thumbnails.length) || (this.mobileThumbnailsContainer && this.mobileThumbnails.length)){     
          // Wait for DOM to be fully rendered before setting width and height
          requestAnimationFrame(() => {
            this._setContainerWidth();
            this._setHeight();
          });
        window.addEventListener('resize', () => {
          this._setContainerWidth();
          this._setHeight(); // Also recalculate height on resize
        });
        
        // Set up desktop thumbnail click handlers
        if (this.thumbnailsContainer && this.thumbnails.length) {
          this.thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', () => {
              this.thumbnails.forEach(thumb => {
                thumb.classList.remove('product-gallery__thumbnail--active');
              });
              thumbnail.classList.add('product-gallery__thumbnail--active');
              this._goToThumbnail(thumbnail.dataset.index);
            });
          });
        }
        
        // Set up mobile thumbnail click handlers
        if (this.mobileThumbnailsContainer && this.mobileThumbnails.length) {
          this.mobileThumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', () => {
              this.mobileThumbnails.forEach(thumb => {
                thumb.classList.remove('product-gallery__thumbnail--active');
              });
              thumbnail.classList.add('product-gallery__thumbnail--active');
              this._goToThumbnail(thumbnail.dataset.index);
            });
          });
        }

        // Mouse drag-to-scroll for the bundle gallery's thumbnail strip
        // (touch and trackpad already scroll natively). Gated on
        // thumbnailsBelow so it stays bundle-only. `is-dragging` swaps the
        // cursor; `dragMoved` suppresses the click that would otherwise fire
        // when a drag ends. Native image drag is disabled via draggable=false
        // plus a dragstart preventDefault, or it would hijack the mousemove.
        if (this.thumbnailsBelow && this.mobileThumbnailsContainer) {
          const strip = this.mobileThumbnailsContainer;

          this.mobileThumbnails.forEach(img => {
            img.draggable = false;
            img.setAttribute('draggable', 'false');
          });
          strip.addEventListener('dragstart', (e) => e.preventDefault());

          let isDown = false;
          let startX = 0;
          let startScrollLeft = 0;
          let dragMoved = false;

          strip.addEventListener('mousedown', (e) => {
            isDown = true;
            dragMoved = false;
            startX = e.pageX;
            startScrollLeft = strip.scrollLeft;
            strip.classList.add('is-dragging');
            e.preventDefault();
          });

          strip.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const dx = e.pageX - startX;
            if (Math.abs(dx) > 3) dragMoved = true;
            strip.scrollLeft = startScrollLeft - dx;
          });

          const release = () => {
            if (!isDown) return;
            isDown = false;
            strip.classList.remove('is-dragging');
          };

          strip.addEventListener('mouseup', release);
          strip.addEventListener('mouseleave', release);

          // Capture-phase: suppress the click that ends a drag.
          strip.addEventListener('click', (e) => {
            if (dragMoved) {
              e.preventDefault();
              e.stopPropagation();
              dragMoved = false;
            }
          }, true);
        }
      }

      // ----------END TD CHANGE---------
    }

    _checkMobile() {
      let afterContent = getComputedStyle(this, ':after').content;
      if ( afterContent.indexOf('mobile-enabled') != -1 ) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    }

    _checkIndex(justClasses=false) {
      if ( justClasses ) {
        this._resetClasses();
      }
      this.items[this.index].classList.add('active');
      if ( this.items[this.index+1] ) {
        this.items[this.index+1].classList.add('after-active');
      } 
      if ( this.items[this.index-1] ) {
        this.items[this.index-1].classList.add('before-active');
      } 
      if ( !justClasses ) {
        this.indexEl.innerHTML = this.index+1;
      }
      // ------------TD CHANGE-----------
      if(this.enableThumbnails && this.thumbnails.length){
        this.thumbnails.forEach(thumbnail => {
          thumbnail.classList.remove('product-gallery__thumbnail--active');
        });
        this.thumbnails[this.index].classList.add('product-gallery__thumbnail--active');
        if (!this.mobile) {
          this._scrollThumbnailsToVisible(this.index);
        }
      }
      
      // Update mobile thumbnails
      if(this.enableThumbnails && this.mobileThumbnails.length){
        this.mobileThumbnails.forEach(thumbnail => {
          thumbnail.classList.remove('product-gallery__thumbnail--active');
        });
        this.mobileThumbnails[this.index].classList.add('product-gallery__thumbnail--active');
        // Scroll mobile thumbnails to keep active thumbnail visible
        this._scrollMobileThumbnailsToVisible(this.index);
      }
      // ----------END TD CHANGE---------
    }

    _checkNav(forceIndex=null){
      let index = forceIndex != null ? forceIndex : this.index;
      this.nextEl.classList.remove('active');
      this.nextEl.classList.remove('disabled');
      this.prevEl.classList.remove('disabled');
      this.nextEl.removeAttribute('disabled');
      this.prevEl.removeAttribute('disabled');
      if ( ! this.items[index+1] ) {
        this.nextEl.classList.add('disabled');
        this.nextEl.setAttribute('disabled', 'disabled');
      }
      if ( ! this.items[index-1] ) {
        this.prevEl.classList.add('disabled');
        this.prevEl.setAttribute('disabled', 'disabled');
      }
      this.indexEl.innerHTML = index+1;
    }

    _getSliderWidth(){
      this.width = this.items[0].getBoundingClientRect().width;
    }

    _repositionSlider(){
      this.holder.classList.add('no-transitions');
      this.holder.style.transform = `translateX(${( this.index * this.width * - 1 )}px`;
      setTimeout(()=>{
        this.holder.classList.remove('no-transitions');
      }, 10);
    }

    _resetClasses(){
      this.items.forEach(item=>{
        item.classList.remove('before-active');
        item.classList.remove('after-active');
        item.classList.remove('active');
      });
    }

    _resetOrder(swapIndex=null){
      this.items.forEach((item, i)=>{
        let order = i;
        if ( swapIndex != null ) {
          if ( i == swapIndex[0] ) {
            order = swapIndex[1];
          } else if ( i == swapIndex[1] ) {
            order = swapIndex[0];
          }
        }
        item.style.order = order;
      })
    }

    _translateSlider(){
      this.holder.style.transform = `translateX(${( this.index * this.width * - 1 )}px`;
      this._checkIndex();
      this._checkNav();
    }

    _blockAnimation(force=false){
      this.animating = true;
      this.timeout = setTimeout(()=>{
        this.animating = false;
        this.dispatchEvent(this.EVENT_SETTLE);
        if ( force ) {
          this._resetOrder();
          this._resetClasses();
          this._checkIndex();
        }
      }, 500);
    }

    _setHeight(forceIndex=null, animation=true){
      let index = forceIndex != null ? forceIndex : this.index;
      if ( !animation ) this.viewport.classList.add('no-transition');
      
      let mainImageHeight = 0;
      if ( this.items[index].querySelector('.lazy-image') ) {
        mainImageHeight = this.items[index].querySelector('.lazy-image').offsetHeight;
      }
      
      // ------------TD CHANGE-----------
      // Thumbnails-below mode sizes via CSS, so clear the legacy inline
      // sizing. Otherwise run the original left-thumbnails math untouched.
      if (this.thumbnailsBelow) {
        if (this.container) this.container.style.width = '';
        if (this.thumbnailsContainer) {
          this.thumbnailsContainer.style.maxHeight = '';
          this.thumbnailsContainer.style.marginLeft = '';
        }
        if (this.viewport) this.viewport.style.height = '';
      } else {
        if(this.enableThumbnails && this.container && !this.mobile){
          // Get the actual image width instead of using height
          const mainImage = this.items[index].querySelector('.lazy-image');
          if (mainImage) {
            const mainImageWidth = mainImage.offsetWidth;
            this.container.style.width = `${mainImageWidth}px`;
          }
        }
        if(this.thumbnailsContainer && !this.mobile){
          this.thumbnailsContainer.style.maxHeight = `${mainImageHeight}px`;
          this.thumbnailsContainer.style.marginLeft = `calc(100% - ${(this.container.offsetWidth + this.thumbnailsContainer.offsetWidth + 10)}px)`;
        }

        // Set viewport height based on main image only
        this.viewport.style.height = `${mainImageHeight}px`;
      }
      // ----------END TD CHANGE---------
      
      if ( !animation ) {
        setTimeout(()=>{
          this.viewport.classList.remove('no-transition');
        }, 20);
      }
    }

    // ------------TD CHANGE-----------
    _suppressObserverDuringScroll() {
      this._programmaticScroll = true;
      clearTimeout(this._programmaticScrollTimeout);
      this._programmaticScrollTimeout = setTimeout(() => {
        this._programmaticScroll = false;
      }, 500);
    }
    // ----------END TD CHANGE---------

    _iOS15snapping() {
      if ( this._ios15 ) {
        this.holder.classList.add('disable-snapping');
      }
      setTimeout(()=>{
        if ( this._ios15 ) {
          this.holder.classList.remove('disable-snapping');
        }
      }, 500);
    }

    nextSlide() {
      if ( ! this.mobile ) {
        if ( ! this.animating ) {
          this._blockAnimation();
          this._resetClasses();
          if ( this.index+1 < this.length ) {
            this.index++;
          }
          this._checkIndex();
          this._checkNav();
          this._setHeight();
          this._translateSlider();
          this.dispatchEvent(this.EVENT_CHANGE);
        }
      } else {
        if ( this.index+1 < this.length ) {
          this.index++;
        }
        // ------------TD CHANGE-----------
        this._suppressObserverDuringScroll();
        // ----------END TD CHANGE---------
        this._iOS15snapping();
        this.holder.scrollTo({
          left: this.items[this.index].offsetLeft - parseInt(getComputedStyle(this.items[this.index]).marginLeft),
          top: 0,
          behavior: 'smooth'
        });
        this._setHeight();
        this._checkNav();
        this._checkIndex(true);
      }
    }

    prevSlide() {
      if ( ! this.mobile ) {
        if ( ! this.animating ) {
          this._blockAnimation();
          this._resetClasses();
          if ( this.index-1 >= 0 ) {
            this.index--;
          }
          this._checkIndex();
          this._checkNav();
          this._setHeight();
          this._translateSlider();
          this.dispatchEvent(this.EVENT_CHANGE);
        }
      } else {
        if ( this.index-1 >= 0 ) {
          this.index--;
        }
        // ------------TD CHANGE-----------
        this._suppressObserverDuringScroll();
        // ----------END TD CHANGE---------
        this._iOS15snapping();
        this.holder.scrollTo({
          left: this.items[this.index].offsetLeft - parseInt(getComputedStyle(this.items[this.index]).marginLeft),
          top: 0,
          behavior: 'smooth'
        });
        this._setHeight();
        this._checkNav();
        this._checkIndex(true);
      }
    }

  // ------------TD CHANGE-----------
  _setContainerWidth() {
    // Thumbnails-below mode is full-width on every viewport, same as mobile.
    if (this.mobile || this.thumbnailsBelow) {
      if(this.container){
        this.container.style.width = '100%';
      }
      return;
    }
    if(this.container && this.thumbnailsContainer){
      this.container.style.width = `calc(100% - ${this.thumbnailsContainer.offsetWidth}px)`;
    }
  }
  _scrollThumbnailsToVisible(index) {
    if (!this.thumbnailsContainer || !this.thumbnails.length) return;
    
    const activeThumb = this.thumbnails[index];
    const container = this.thumbnailsContainer;
    
    if (!activeThumb) return;
    
    const containerRect = container.getBoundingClientRect();
    const thumbRect = activeThumb.getBoundingClientRect();
    
    // Check if thumbnail is above the visible area
    if (thumbRect.top < containerRect.top) {
      // Scroll up to show the thumbnail
      const scrollTop = container.scrollTop - (containerRect.top - thumbRect.top) - 10;
      container.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: 'smooth'
      });
      return; // Exit early since we handled the scroll
    }
    
    // Check if thumbnail is below the visible area
    if (thumbRect.bottom > containerRect.bottom) {
      // Scroll down to show the thumbnail
      const scrollTop = container.scrollTop + (thumbRect.bottom - containerRect.bottom) + 10;
      container.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
      return; // Exit early since we handled the scroll
    }
    
    // If we get here, the current thumbnail is visible
    // Check if we need to scroll to show next thumbnail (bottom edge case)
    if (index < this.thumbnails.length - 1) {
      const nextThumb = this.thumbnails[index + 1];
      if (nextThumb) {
        const nextThumbRect = nextThumb.getBoundingClientRect();
        // If next thumbnail is not visible, scroll to show it
        if (nextThumbRect.bottom > containerRect.bottom || nextThumbRect.top >= containerRect.bottom) {
          const scrollAmount = nextThumbRect.height + 10;
          container.scrollTo({
            top: container.scrollTop + scrollAmount,
            behavior: 'smooth'
          });
          return; // Exit early since we handled the scroll
        }
      }
    }
    
    // Check if we need to scroll to show previous thumbnail (top edge case)
    if (index > 0) {
      const prevThumb = this.thumbnails[index - 1];
      if (prevThumb) {
        const prevThumbRect = prevThumb.getBoundingClientRect();
        // If previous thumbnail is not visible, scroll to show it
        if (prevThumbRect.top < containerRect.top || prevThumbRect.bottom <= containerRect.top) {
          const scrollAmount = prevThumbRect.height + 10;
          container.scrollTo({
            top: Math.max(0, container.scrollTop - scrollAmount),
            behavior: 'smooth'
          });
        }
      }
    }
  }

  _scrollMobileThumbnailsToVisible(index) {
    // Native mobile and the thumbnails-below desktop layout both use the
    // .product-gallery__thumbnails--mobile strip and auto-scroll it.
    if (!this.mobile && !this.thumbnailsBelow) return;
    if (!this.mobileThumbnailsContainer || !this.mobileThumbnails.length) return;

    const activeThumb = this.mobileThumbnails[index];
    const container = this.mobileThumbnailsContainer;
    if (!activeThumb) return;

    const cRect = container.getBoundingClientRect();
    const tRect = activeThumb.getBoundingClientRect();

    const hasPrev = index > 0;
    const hasNext = index < this.mobileThumbnails.length - 1;
    const leftSlack = tRect.left - cRect.left;
    const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);

    let target = null;
    if (hasPrev && hasNext) {
      const targetLeftSlack = (cRect.width - tRect.width) / 2;
      target = container.scrollLeft + (leftSlack - targetLeftSlack);
    } else if (!hasPrev) {
      target = 0;
    } else {
      target = maxScroll;
    }

    target = Math.max(0, Math.min(target, maxScroll));
    if (Math.abs(target - container.scrollLeft) > 2) {
      container.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    }
  }
  _goToThumbnail(index) {
    if (this.animating) return;
    const parsedIndex = parseInt(index, 10);
    if (isNaN(parsedIndex) || parsedIndex < 0 || parsedIndex >= this.thumbnails.length) {
      console.warn(`Invalid index passed to _goToThumbnail: ${index}`);
      return;
    }
    this.index = parsedIndex;
    
    if (this.mobile) {
      this._suppressObserverDuringScroll();
      this._iOS15snapping();
      this.holder.scrollTo({
        left: this.items[this.index].offsetLeft - parseInt(getComputedStyle(this.items[this.index]).marginLeft),
        top: 0,
        behavior: 'smooth'
      });
      this._setHeight();
      this._checkNav();
      this._checkIndex(true);
    } else {
      this._blockAnimation();
      this._resetClasses();
      this._translateSlider();
      this._setHeight();
      this._checkIndex();
      this._checkNav();
      // Auto-scroll thumbnails to keep active one visible
      this._scrollThumbnailsToVisible(this.index);
    }
  }
  // ----------END TD CHANGE---------

    // Cleanup method to remove event listeners when component is unmounted
    disconnectedCallback() {
      // Remove global event listeners to prevent memory leaks
      if (this.boundResizeHandler) {
        window.removeEventListener('resize', this.boundResizeHandler);
        window.removeEventListener('td:section-switcher-changed', this.boundResizeHandler);
      }
      
      // Disconnect the intersection observer
      if (this.OBSERVER) {
        this.OBSERVER.disconnect();
      }
    }

  }

	if (typeof customElements.get("product-slider") == "undefined") {
    customElements.define('product-slider', ProductSlider);
  }

}
